@if (lineItem) {
  <section
    class="sticky top-[60px] z-[2] w-full rounded-none border-none bg-white max-[767px]:relative max-[767px]:top-0 max-[767px]:z-0 max-[767px]:m-0 max-[767px]:flex max-[767px]:w-full max-[767px]:flex-wrap max-[767px]:justify-between max-[767px]:overflow-y-auto max-[767px]:rounded-none max-[767px]:p-0"
  >
    @if (isLineItemAvailable) {
      <div
        class="max-[767px]:h-full max-[767px]:min-h-[calc(100vh-212px)] max-[767px]:w-full max-[767px]:pr-0"
      >
        <app-detail-header
          [order]="order"
          [browserSize]="browserSize"
        ></app-detail-header>

        <div
          class="text-navy-700 mt-4 border-b border-gray-500 pb-4 text-sm max-[767px]:m-0 max-[767px]:px-5 max-[767px]:py-4"
        >
          <div
            class="flex items-center pl-7 text-sm tracking-wide text-black uppercase max-[860px]:pl-0"
          >
            <!-- <mat-icon class="mr-1 !h-4 !w-4 text-[1rem]">
              location_on
            </mat-icon> -->
            {{ lineItem.Location__r?.Name }}
          </div>
        </div>

        <div
          class="text-navy-700 mt-4 border-b border-gray-500 pb-4 text-sm max-[767px]:m-0 max-[767px]:px-5 max-[767px]:py-4"
        >
          <div
            class="flex items-center pl-7 text-sm tracking-wide text-black uppercase max-[860px]:pl-0"
          >
            <!-- <mat-icon class="mr-1 !h-4 !w-4 text-[1rem]">
              account_tree
            </mat-icon> -->
            Service Order:
            <span class="ml-1 font-semibold">{{
              lineItem.Service_Order2__r?.Name || 'N/A'
            }}</span>
          </div>
        </div>

        @if (lineItem.Service__c) {
          <div
            class="text-navy-700 mt-4 border-b border-gray-500 pb-4 text-sm max-[767px]:m-0 max-[767px]:px-5 max-[767px]:py-4"
          >
            <div
              class="flex justify-between pl-8 max-[1100px]:flex-col max-[1100px]:gap-4 max-[860px]:pl-5 max-[767px]:gap-6 max-[767px]:pl-0"
            >
              <div class="flex-1">
                <div class="font-sm text-sm uppercase">
                  Service:
                  <span class="ml-1 font-semibold">{{
                    lineItem.Service__r?.Name || 'N/A'
                  }}</span>
                </div>
                <div class="space-y-1.5 pt-1.5 pl-4">
                  <div class="type">
                    <span class="text-gray-600">Type:</span>
                    {{ lineItem.Service_Type__c || 'N/A' }}
                  </div>
                  <div class="bandwidth">
                    <span class="text-gray-600">Bandwidth:</span>
                    {{ lineItem.Service__r?.Bandwidth_Downstream__c || 'N/A' }}
                    @if (lineItem.Service__r?.Asymmetrical_Bandwidth__c) {
                      / {{ lineItem.Service__r?.Bandwidth_Upstream__c }}
                    }
                  </div>
                  <div>
                    <span class="text-gray-600">Connector Type:</span>
                    {{
                      lineItem.Service__r?.Connector_Type_Z_Location__c
                        ? lineItem.Service__r?.Connector_Type_Z_Location__c
                        : 'N/A'
                    }}
                  </div>
                  <div>
                    <span class="text-gray-600">Term:</span>
                    {{ lineItem?.Term__c || 'N/A' }}
                  </div>
                </div>
              </div>
              @if (
                lineItem.Service_Order2__r &&
                lineItem.Service_Order2__r.Status__c !== 'Canceled'
              ) {
                <div
                  class="flex flex-col items-center text-center max-[400px]:ml-[-10px]"
                >
                  <app-line-items-status
                    class="w-full"
                    [tasks]="tasks$ | async"
                    [orderType]="
                      $safeNavigationMigration(lineItem.RecordType?.Name)
                    "
                  ></app-line-items-status>
                  @if (lineItem.Service_Order2__r?.Completed_Date__c) {
                    <div
                      class="text-darkBlue-200 mt-7 text-center text-[15px] font-bold uppercase"
                    >
                      <span class="text-navy-700">Completed Date:</span>
                      {{
                        $safeNavigationMigration(
                          lineItem.Service_Order2__r?.Completed_Date__c
                        ) | date: 'M/d/yy'
                      }}
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        }

        <div
          class="text-navy-700 mt-4 pb-4 pl-8 text-sm max-[860px]:pl-5 max-[767px]:px-5 max-[767px]:pb-12"
        >
          <div class="space-y-1">
            <div class="sales-rep">
              Sales Representative:
              @if (order.Sales_Rep__r) {
                <a
                  class="cursor-pointer text-[#0D62FF] underline"
                  (click)="
                    viewContactInformation(
                      order.Sales_Rep__r,
                      'Sales Representative'
                    )
                  "
                >
                  {{ order.Sales_Rep__r.Name }}
                </a>
              } @else {
                <span class="text-gray-600">N/A</span>
              }
            </div>
            <div>
              Account Manager:
              @if (order.Account_Manager__r) {
                <a
                  class="cursor-pointer text-[#0D62FF] underline"
                  (click)="
                    viewContactInformation(
                      order.Account_Manager__r,
                      'Account Manager'
                    )
                  "
                >
                  {{ order.Account_Manager__r.Name }}
                </a>
              } @else {
                <span class="text-gray-600">N/A</span>
              }
            </div>
            <div>
              Client Project Manager:
              @if (order.Default_Task_Assignments__r) {
                <a
                  class="cursor-pointer text-[#0D62FF] underline"
                  (click)="
                    viewContactInformation(
                      order.Default_Task_Assignments__r?.records[0].User__r,
                      'Client Project Manager'
                    )
                  "
                >
                  {{
                    order.Default_Task_Assignments__r?.records[0]?.User__r?.Name
                  }}
                </a>
              } @else {
                <span class="text-gray-600">N/A</span>
              }
            </div>
          </div>
        </div>
      </div>
    } @else if (!areOrdersLoading) {
      <div
        class="flex flex-col items-center justify-center px-5 py-10 text-center text-sm text-gray-600"
      >
        <p>The line item you are requesting does not exist.</p>
      </div>
    }
    <app-footer class="hidden w-full max-[767px]:block"></app-footer>
  </section>
}
